import React from 'react';
import { I18n } from '@aws-amplify/core';
import { Col, Form } from 'antd';

import { WorkstationSelect } from '@/components/ui/Inputs/WorkstationSelect';
import { useApplicationContext } from '@/context/v1/Application/context';
import { useWorkstations } from '@/hooks/v1';

const { useFormInstance, useWatch } = Form;

export const Workstations = () => {
	const form = useFormInstance();
	const { company, organization } = useApplicationContext();

	const lineId = useWatch('line_id', form);
	const workstationId = useWatch('workstation_id', form);

	const {
		data: workstations,
		isLoading,
		isFetching,
		isError
	} = useWorkstations({ organization_id: organization?.id, company_id: company?.id, line_id: lineId });

	function handleWorkstationSelect(id: string) {
		form.setFieldValue(['workstation_id'], id);
	}

	function handleClearWorkstations() {
		form.setFieldValue(['workstation_id'], '');
	}

	return (
		<Col xs={24} sm={12}>
			<Form.Item
				name={['workstation_id']}
				label={I18n.get('Workstation')}
				rules={[
					{
						required: true,
						message: I18n.get('Select the workstation')
					}
				]}
			>
				<WorkstationSelect
					lineId={lineId}
					loading={isFetching}
					fieldName="workstation_id"
					workstations={workstations}
					workstationId={workstationId}
					disabled={isLoading || isFetching || isError}
					handleSelectWorkstation={handleWorkstationSelect}
					handleClearWorkstations={handleClearWorkstations}
				/>
			</Form.Item>
		</Col>
	);
};
